import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import './NotFound.css'

function NotFound() {
    return (
        <Grid id="notfound" sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            background: 'linear-gradient(135deg, #F0F7FF 0%, #E9CEFD 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <Box className="notfound" sx={{ textAlign: 'center', zIndex: 2 }}>
                <motion.div
                    animate={{ 
                        y: [0, -20, 0],
                        rotateZ: [0, 2, 0, -2, 0]
                    }}
                    transition={{ duration: 3, repeat: Infinity }}
                >
                    <Box className="notfound-404" sx={{ mb: 3 }}>
                        <Typography 
                            variant="h1" 
                            component="h1" 
                            sx={{ 
                                fontWeight: 'bold', 
                                fontSize: { xs: '6rem', md: '8rem' },
                                background: 'linear-gradient(135deg, #0959AA 0%, #6709AA 100%)',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                color: 'transparent',
                                letterSpacing: '-0.02em'
                            }}
                        >
                            404
                        </Typography>
                    </Box>
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                >
                    <Typography 
                        variant="h2" 
                        component="h2" 
                        sx={{ 
                            fontWeight: 'bold', 
                            fontSize: { xs: '1.75rem', md: '2.5rem' },
                            mb: 2,
                            color: 'text.primary'
                        }}
                    >
                        Page not found
                    </Typography>
                    <Typography 
                        variant="body1" 
                        color="text.secondary"
                        sx={{ mb: 4, maxWidth: '400px', mx: 'auto' }}
                    >
                        The page you're looking for doesn't exist or has been moved. Let's get you back on track.
                    </Typography>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                >
                    <Button
                        component={RouterLink}
                        to="/home"
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{ 
                            mt: 2,
                            textTransform: 'none',
                            fontSize: '1rem',
                            px: 4,
                            py: 1.5,
                            borderRadius: '10px'
                        }}
                    >
                        Back to Homepage
                    </Button>
                </motion.div>
            </Box>
        </Grid>
    );
}

export default NotFound;